import car from "../Car";
import equipment from "../Equipment";
import box from "../Box";
import hospital from "../Hospital";
/**
 *基础数据路由
 */
const Basics = [
    {
        name: '车辆配置',
        path: '/basic/car',
        component: car
    },
    {
        name: '设备管理',
        path: '/basic/equipment',
        component: equipment
    },
    {
        name: '周转箱管理',
        path: '/basic/box',
        component: box
    },
    {
        name: '医疗机构管理',
        path: '/basic/hospital',
        component: hospital
    },
];
export default Basics
